import { CreateButton } from 'components/button/CreateButton';
import { DocumentTitle } from 'components/DocumentTitle';
import { DebouncedSearchInput } from 'components/data/DebouncedSearchInput';
import { TablePageLayout } from 'components/page/styled';
import { usePermissions } from 'contexts/PermissionsContext';
import { usePagedLocationsDataSource } from 'custom_hooks/data_hooks/data_source/locationsDataSource';
import { CreateLocationModal } from 'pages/Settings/Locations/CreateLocationModal';
import { LocationsTable } from 'pages/Settings/Locations/LocationsTable';
import { SearchCreateButtonContainer } from 'pages/Settings/shared/styled';
import { useEffect, useState } from 'react';
import { ContextualPageProps } from 'utils/types';

export function LocationsPage({ corporation, location }: ContextualPageProps) {
    const { canEditLocationDetails } = usePermissions();
    const dataSource = usePagedLocationsDataSource({
        name: 'locations-table',
        defaultFilter: {
            nameSearch: '',
            corporationId: corporation?.Id,
            locationId: location?.Id,
        },
    });

    const [addModalOpen, setAddModalOpen] = useState(false);
    const [nameSearch, setNameSearch] = useState('');
    const { setFilter, reloadPage } = dataSource;

    const onLocationsCreate = () => {
        setAddModalOpen(false);
        reloadPage();
    };

    useEffect(() => {
        setFilter((currentFilter) => ({
            ...currentFilter,
            nameSearch,
            corporationId: corporation?.Id,
            locationId: location?.Id,
        }));
    }, [corporation?.Id, nameSearch, location?.Id, setFilter]);

    return (
        <TablePageLayout>
            <DocumentTitle title={`${corporation?.Name ?? ''} Locations Settings`} />
            <SearchCreateButtonContainer>
                <DebouncedSearchInput
                    placeholder="Search"
                    value={nameSearch}
                    onChange={setNameSearch}
                />
                <div className="flex-grow-1" />
                {canEditLocationDetails && (
                    <CreateButton onClick={() => setAddModalOpen(true)} />
                )}
                {addModalOpen && (
                    <CreateLocationModal
                        onCreate={onLocationsCreate}
                        onClose={() => setAddModalOpen(false)}
                    />
                )}
            </SearchCreateButtonContainer>
            <LocationsTable dataSource={dataSource} />
        </TablePageLayout>
    );
}
